import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VBtnToggle,{attrs:{"color":"primary"},model:{value:(_vm.vt.filter),callback:function ($$v) {_vm.$set(_vm.vt, "filter", $$v)},expression:"vt.filter"}},[_c(VBtn,{attrs:{"width":"70px","small":"","value":true,"text":""}},[_c(VIcon,[_vm._v("mdi-check")])],1),_c(VBtn,{attrs:{"width":"70px","small":"","value":false,"text":""}},[_c(VIcon,[_vm._v("mdi-close")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }